import React from 'react';
import './FlipCards.css';

import FlipCard from './FlipCard';

const flipCards = ( props ) => {
	let cardDisplay = null;
	
	if( props.cards ) {
		cardDisplay = props.cards.map( card => {
			card.className = props.className;
			
			return <FlipCard key={ card.id } className={ card.className } { ...card } />;
		});
	}
	
	return (
		<div className="FlipCards">
			{ cardDisplay }
		</div>
	);
};

export default flipCards;



// WEBPACK FOOTER //
// ./src/components/FlipCards/FlipCards.js